import angular from 'angular';
import template from './item.html';
import './item.scss';
class ModalsItemController {
    constructor() { }
    $onInit() { }
}
const modalsItem = {
    template,
    transclude: true,
    bindings: {
        header: '<',
        onClose: '&',
    },
    controller: ModalsItemController,
};
export default angular
    .module('doxy.common.components.modals.item', [])
    // modals-item
    .component('modalsItem', modalsItem).name;
